import { baseRestApi } from "api/rest/baseRestApi";

module.hot?.accept();

type ExportConversationHistoryResponse = {
  data: {
    jobId: string;
  };
};

type GetConversationHistoryDownloadResponse = {
  data: {
    downloadUrl?: string;
    fileName?: string;
  };
};

interface ExportConversationHistoryArgs {
  conversationId: number;
}

interface GetConversationHistoryDownloadArgs {
  conversationId: number;
  jobId: string;
}

const downloadConversationHistoryApi = baseRestApi.injectEndpoints({
  overrideExisting: module.hot?.status() === "apply",
  endpoints: (builder) => ({
    exportConversationHistory: builder.mutation<{ jobId: string }, ExportConversationHistoryArgs>({
      query: ({ conversationId }) => ({
        method: "POST",
        url: `shipper/conversations/${conversationId}/export/`,
      }),
      transformResponse: (response: ExportConversationHistoryResponse) => ({
        jobId: response.data.jobId,
      }),
    }),
    getConversationHistoryDownload: builder.query<
      { downloadUrl?: string; fileName?: string },
      GetConversationHistoryDownloadArgs
    >({
      query: ({ conversationId, jobId }) => ({
        method: "GET",
        url: `shipper/conversations/${conversationId}/export/${jobId}/`,
      }),
      transformResponse: (response: GetConversationHistoryDownloadResponse) => ({
        downloadUrl: response.data.downloadUrl,
        fileName: response.data.fileName,
      }),
    }),
  }),
});

export default downloadConversationHistoryApi;
export const { useExportConversationHistoryMutation, useGetConversationHistoryDownloadQuery } =
  downloadConversationHistoryApi;
